import {
  ComponentFactory,
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import { MatSpinner } from '@angular/material/progress-spinner';
import { timeout } from 'rxjs/operators';

@Directive({
  selector: '[appSubmitButton]'
})
export class SubmitButtonDirective implements OnChanges {
  spinner: MatSpinner = {} as any;
  spinnerContainer: any;
  factory: ComponentFactory<MatSpinner>;
  @Input() isLoading: boolean = false;

  constructor(
    private el: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
    this.factory = this.componentFactoryResolver.resolveComponentFactory(MatSpinner);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.isLoading.currentValue !== changes.isLoading.previousValue) {
      const el = this.el.nativeElement;
      if (this.isLoading) {
        this.spinnerContainer = this.renderer.createElement('div');
        this.renderer.addClass(this.spinnerContainer, 'submit-btn-loading-container');
        const componentRef = this.viewContainerRef.createComponent(this.factory);
        this.spinner = componentRef.instance;
        this.spinner.diameter = 24;
        this.renderer.appendChild(this.spinnerContainer, this.spinner._elementRef.nativeElement);
        timeout(50);
        this.renderer.appendChild(el, this.spinnerContainer);
      } else {
        if (el.querySelector('mat-spinner')) {
          this.renderer.removeChild(el, this.spinnerContainer);
        }
      }
    }
  }
}
